import React, { useState } from 'react'
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core'
import { Button } from '../../atoms/Button'
import PropTypes from 'prop-types'
import { downloadOptions, downloadChart } from '../../../configs/statisticConfig'
import useDownloadStatisticExcel from '../../../hooks/services/useDownloadStatisticExcel'
import useStatistics from '../../../hooks/useStatistics'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import DownloadIcon from '../../atoms/icons/DownloadIcon'
import { downloadTypes } from '../../../constants/statistics'

const DownloadChart = ({
  title,
  excelKindDownload,
  downloadAvailable = [downloadTypes.picture],
  onExcelDownload,
  chartImageURI
}) => {
  const location = useLocation()
  const [downloadOption, setDownloadOption] = useState(downloadTypes.picture)
  const { generateExcel } = useDownloadStatisticExcel(excelKindDownload)
  const filteredDownloadOptions = downloadOptions.filter(option => downloadAvailable.includes(option.id))
  const { getDownloadedStatus } = useStatistics()
  const filters = queryString.parse(location.search, { arrayFormat: 'bracket' })
  const { data: downloadedStatus } = getDownloadedStatus(
    ['downloadedStatus'],
    {},
    {
      refetchOnWindowFocus: true,
      enabled: downloadAvailable.includes('excel')
    }
  )

  const handleChangeOption = event => {
    setDownloadOption(event.target.value)
  }

  const handleDownload = () => {
    if (downloadOption === downloadTypes.picture) {
      downloadChart(chartImageURI, title)
    }
    if (downloadOption === downloadTypes.excel || downloadOption === downloadTypes.monthlyExcel) {
      generateExcel(filters, {
        onSuccess: () => {
          onExcelDownload()
        },
        onError: error => {
          const message =
            error?.response?.data?.error ||
            'Ocurrió un error al procesar la solicitud de descarga. Intente nuevamente.'
          alert(message)
        }
      })
    }
  }

  return (
    <div className="px-4">
      <p className="font-bold" id="download-option-label">
        Opciones de descarga
      </p>
      <RadioGroup
        className="mb-5 mt-2"
        aria-labelledby="download-option-label"
        value={downloadOption}
        onChange={handleChangeOption}
      >
        {filteredDownloadOptions.map(option => (
          <FormControlLabel
            classes={{ label: 'text-base' }}
            key={option.id}
            value={option.id}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
      <Button
        onClick={handleDownload}
        variant="secondary"
        size="full"
        className="w-full"
        disabled={
          [downloadTypes.monthlyExcel, downloadTypes.excel].includes(downloadOption) &&
          downloadedStatus?.status === 'EN PROCESO'
        }
      >
        <DownloadIcon className="mr-2" />
        Descargar
      </Button>
    </div>
  )
}

export default DownloadChart

DownloadChart.propTypes = {
  title: PropTypes.string.isRequired,
  excelKindDownload: PropTypes.string,
  downloadAvailable: PropTypes.arrayOf(PropTypes.string),
  onExcelDownload: PropTypes.func,
  chartImageURI: PropTypes.string
}
